// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "money.unstoppable",
    name: "Unstoppable Wallet",
    homepage: "https://unstoppable.money/",
    image_id: "a63cbfce-0726-4f94-9187-a761afb94400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/unstoppable-crypto-wallet/id1447619907",
        android: "https://play.google.com/store/apps/details?id=io.horizontalsystems.bankwallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "unstoppable.money://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map